export const SINGPASS_CONSENT_FORM_CALLBACK_AUTH_CODE = 'code';
export const SINGPASS_CONSENT_FORM_CALLBACK_ERROR_CODE = 'error';
export const SINGPASS_CONSENT_FORM_CALLBACK_STATE = 'state';
export const SINGPASS_CONSENT_FORM_CALLBACK_ERROR_DESCRIPTION = 'error-description';
